var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"}),(!_vm.showDetail)?_c('div',{staticClass:"form-body"},[_vm._v(" Click on a record to view more details. ")]):_vm._e(),(_vm.showDetail)?_vm._t("details"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }